/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressNewApiModel } from './addressNewApiModel';
import { UserRegistrationApiModel } from './userRegistrationApiModel';


export interface ProviderTenantCreateApiModel { 
    user: UserRegistrationApiModel;
    tenantName: string;
    companyIco: string;
    companyDic: string;
    companyIcDPH: string;
    companyName: string;
    alias: string;
    addressDto: AddressNewApiModel;
}

